import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
const TextFieldGroup = ({ prefixCls, onBlur, children, className, ...otherProps }) => {
    const ref = useRef(null);
    const selfPrefixCls = `${prefixCls}-group-wrapper`;
    useEffect(() => {
        const { current } = ref;
        if (current && onBlur) {
            const handleMousedown = (e) => {
                const { target } = e;
                if (!e.defaultPrevented && !current.contains(target)) {
                    onBlur(e);
                }
            };
            document.addEventListener('mousedown', handleMousedown, false);
            return () => {
                document.removeEventListener('mousedown', handleMousedown, false);
            };
        }
    }, [onBlur, ref]);
    return (React.createElement("div", Object.assign({ ref: ref }, otherProps, { className: classNames(selfPrefixCls, className) }), children));
};
TextFieldGroup.displayName = 'TextFieldGroup';
export default TextFieldGroup;
